/**
 * Component de loading da inicialização
 */

import React from 'react';
import { useAppInitialization } from './useAppInitialization';

interface AppInitializationLoaderProps {
  children: React.ReactNode;
}

export const AppInitializationLoader: React.FC<AppInitializationLoaderProps> = ({ children }) => {
  const { isInitialized, isLoading, error, retry } = useAppInitialization();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Inicializando aplicação...</p>
          <p className="text-sm text-gray-500 mt-2">Configurando sistemas de plataforma e ciclo de vida</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-red-50">
        <div className="text-center max-w-md">
          <div className="text-red-600 text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-red-800 mb-2">Erro na Inicialização</h2>
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={retry}
            className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition-colors"
          >
            Tentar Novamente
          </button>
        </div>
      </div>
    );
  }

  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-yellow-50">
        <div className="text-center">
          <div className="text-yellow-600 text-6xl mb-4">⏳</div>
          <h2 className="text-2xl font-bold text-yellow-800 mb-2">Inicializando...</h2>
          <p className="text-yellow-600">Preparando ambiente da aplicação</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
